import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

const AuthRoute = ({ authenticate }) => {
    const { state } = useLocation();

    return authenticate ? state && state.pathname ? <Navigate to={state.pathname} /> : <Navigate to="/" /> : <Outlet />

}

export default AuthRoute